import { ReactChild, ReactChildren, useCallback, useEffect, useState } from "react";
import React, { Component } from "react";

const useCopyToClipboard = (text, notifyTimeout = 2500) => {
	const [copyStatus, setCopyStatus] = useState("inactive");
	const copy = useCallback(() => {
		navigator.clipboard.writeText(text).then(
			() => setCopyStatus("copied"),
			() => setCopyStatus("failed")
		);
	}, [text]);

	useEffect(() => {
		if (copyStatus === "inactive") {
			return;
		}

		const timeoutId = setTimeout(() => setCopyStatus("inactive"), notifyTimeout);

		return () => clearTimeout(timeoutId);
	}, [copyStatus]);

	return [copyStatus, copy];
};

const CopyUrlButton = ({
	text,
	children,
}: {
	text: string;
	children?: ReactChildren | ReactChild | Element | Element[] | JSX.Element | JSX.Element[];
}) => {
	const [copyUrlStatus, copyUrl] = useCopyToClipboard(text);
	let buttonText = "Copy URL";

	if (copyUrlStatus === "copied") {
		buttonText = "Copied";
	} else if (copyUrlStatus === "failed") {
		buttonText = "Copy failed!";
	}

	return (
		//@ts-ignore
		<div className="button secondaryButton" onClick={copyUrl}>
			{buttonText}
		</div>
	);
};

export default CopyUrlButton;
